// Mock data for tournaments
const mockTournaments = [
  {
    id: 't123',
    name: 'Liga de Abril',
    type: 'single_elimination',
    status: 'open',
    startDate: '2025-05-15',
    rules: 'Formato estándar. Mejor de 3 partidas. Se prohíben los mazos de Atlantes con más de 3 copias de "Diluvio Universal".',
    location: 'Tienda GameZone, Santiago',
    participants: [
      { id: 1, username: "Jugador1", avatarUrl: "https://mui.com/static/images/avatar/1.jpg", mainDeck: "Atlantes" },
      { id: 2, username: "Jugador2", avatarUrl: "https://mui.com/static/images/avatar/2.jpg", mainDeck: "Egipcios" },
      { id: 3, username: "Jugador3", avatarUrl: "https://mui.com/static/images/avatar/3.jpg", mainDeck: "Nórdicos" },
      { id: 4, username: "Jugador4", avatarUrl: "https://mui.com/static/images/avatar/4.jpg", mainDeck: "Griegos" }
    ],
    announcements: [
      { id: 1, message: "Inscripciones abiertas hasta el 10 de mayo", date: "2025-04-30" }
    ],
    matches: []
  },
  {
    id: 't124',
    name: 'Torneo Nacional MyL',
    type: 'double_elimination',
    status: 'in_progress',
    startDate: '2025-04-10',
    rules: 'Formato avanzado. Prohibidas las cartas de la expansión "Templo Maldito". Se permite sideboard de 12 cartas.',
    location: 'Centro de Convenciones, Buenos Aires',
    participants: [
      { id: 1, username: "Jugador1", avatarUrl: "https://mui.com/static/images/avatar/1.jpg", mainDeck: "Atlantes" },
      { id: 2, username: "Jugador2", avatarUrl: "https://mui.com/static/images/avatar/2.jpg", mainDeck: "Egipcios" },
      { id: 3, username: "Jugador3", avatarUrl: "https://mui.com/static/images/avatar/3.jpg", mainDeck: "Nórdicos" },
      { id: 4, username: "Jugador4", avatarUrl: "https://mui.com/static/images/avatar/4.jpg", mainDeck: "Griegos" },
      { id: 5, username: "Jugador5", avatarUrl: "https://mui.com/static/images/avatar/5.jpg", mainDeck: "Japoneses" },
      { id: 6, username: "Jugador6", avatarUrl: "https://mui.com/static/images/avatar/6.jpg", mainDeck: "Atlantes" },
      { id: 7, username: "Jugador7", avatarUrl: "https://mui.com/static/images/avatar/7.jpg", mainDeck: "Romanos" },
      { id: 8, username: "Jugador8", avatarUrl: "https://mui.com/static/images/avatar/8.jpg", mainDeck: "Ingleses" }
    ],
    announcements: [
      { id: 1, message: "El torneo comenzará a las 10:00 AM", date: "2025-04-08" },
      { id: 2, message: "Primera ronda completada. Segunda ronda comienza en 30 minutos", date: "2025-04-10" }
    ],
    matches: [
      // Winners bracket
      { id: 1, round: 1, bracket: 'winners', player1: "Jugador1", player2: "Jugador8", winner: "Jugador1" },
      { id: 2, round: 1, bracket: 'winners', player1: "Jugador4", player2: "Jugador5", winner: "Jugador4" },
      { id: 3, round: 1, bracket: 'winners', player1: "Jugador2", player2: "Jugador7", winner: "Jugador7" },
      { id: 4, round: 1, bracket: 'winners', player1: "Jugador3", player2: "Jugador6", winner: "Jugador3" },
      { id: 5, round: 2, bracket: 'winners', player1: "Jugador1", player2: "Jugador4", winner: "Jugador1" },
      { id: 6, round: 2, bracket: 'winners', player1: "Jugador7", player2: "Jugador3", winner: "Jugador3" },
      { id: 7, round: 3, bracket: 'winners', player1: "Jugador1", player2: "Jugador3", winner: null },
      // Losers bracket
      { id: 8, round: 1, bracket: 'losers', player1: "Jugador8", player2: "Jugador5", winner: "Jugador5" },
      { id: 9, round: 1, bracket: 'losers', player1: "Jugador2", player2: "Jugador6", winner: "Jugador2" },
      { id: 10, round: 2, bracket: 'losers', player1: "Jugador4", player2: "Jugador5", winner: "Jugador5" },
      { id: 11, round: 2, bracket: 'losers', player1: "Jugador7", player2: "Jugador2", winner: "Jugador7" },
      { id: 12, round: 3, bracket: 'losers', player1: "Jugador5", player2: "Jugador7", winner: null }
    ]
  },
  {
    id: 't125',
    name: 'Copa Sudamericana MyL',
    type: 'round_robin',
    status: 'completed',
    startDate: '2025-03-01',
    endDate: '2025-03-02',
    rules: 'Formato estándar. Cada jugador se enfrenta a todos los demás una vez. Los dos mejores avanzan a la final.',
    location: 'Tienda TCG Master, Lima',
    participants: [
      { id: 1, username: "Jugador1", avatarUrl: "https://mui.com/static/images/avatar/1.jpg", mainDeck: "Atlantes" },
      { id: 2, username: "Jugador2", avatarUrl: "https://mui.com/static/images/avatar/2.jpg", mainDeck: "Egipcios" },
      { id: 3, username: "Jugador3", avatarUrl: "https://mui.com/static/images/avatar/3.jpg", mainDeck: "Nórdicos" },
      { id: 4, username: "Jugador4", avatarUrl: "https://mui.com/static/images/avatar/4.jpg", mainDeck: "Griegos" }
    ],
    winner: { id: 2, username: "Jugador2" },
    announcements: [
      { id: 1, message: "Torneo finalizado. Felicitaciones a Jugador2 por el campeonato", date: "2025-03-02" }
    ],
    matches: [
      { id: 1, player1: "Jugador1", player2: "Jugador2", winner: "Jugador2" },
      { id: 2, player1: "Jugador3", player2: "Jugador4", winner: "Jugador3" },
      { id: 3, player1: "Jugador1", player2: "Jugador3", winner: "Jugador1" },
      { id: 4, player1: "Jugador2", player2: "Jugador4", winner: "Jugador2" },
      { id: 5, player1: "Jugador1", player2: "Jugador4", winner: "Jugador1" },
      { id: 6, player1: "Jugador2", player2: "Jugador3", winner: "Jugador2" },
      { id: 7, player1: "Jugador2", player2: "Jugador1", winner: "Jugador2" } // Final
    ]
  },
  {
    id: 't126',
    name: 'Torneo Express',
    type: 'single_elimination',
    status: 'open',
    startDate: '2025-05-20',
    rules: 'Formato rápido. Mejor de 1 partida.',
    location: 'Online',
    participants: [
      { id: 9, username: "Jugador9", avatarUrl: "https://mui.com/static/images/avatar/9.jpg", mainDeck: "Persas" },
      { id: 10, username: "Jugador10", avatarUrl: "https://mui.com/static/images/avatar/10.jpg", mainDeck: "Atlantes" }
    ],
    announcements: [],
    matches: []
  }
];

export default mockTournaments; 